export default __webpack_public_path__ + "static/media/Flag of American Samoa.25f2c49b.gif";